module.exports = __webpack_public_path__ + "84aa2ff7b5281863b1f49e8393b08121.svg";